<script setup>
import { TooltipTrigger } from 'radix-vue'
</script>

<template>
  <TooltipTrigger as-child>
    <slot />
  </TooltipTrigger>
</template>
